import { getOwnerDisplayName } from '../utils/sharing-utils';
import * as i0 from "@angular/core";
/**
 * Returns the display name of the owner for the given item.
 *
 * @param item - The item object from which to extract the owner's display name.
 * @returns The owner's display name as a string.
 */
export class GetOwnerDisplayName {
    transform(item) {
        if (!item || !item.sharing) {
            return 'Me';
        }
        return getOwnerDisplayName(item.sharing);
    }
}
GetOwnerDisplayName.ɵfac = function GetOwnerDisplayName_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GetOwnerDisplayName)(); };
GetOwnerDisplayName.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "getOwnerDisplayName", type: GetOwnerDisplayName, pure: true, standalone: false });
